import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';

import { RFQ } from '@app/core/quotes';
import { SalesService } from '@app/core/sales/services/sales.service';

@Component({
  selector: 'cnc-sku-stock-details',
  templateUrl: './sku-stock-details.component.html',
  styleUrls: ['./sku-stock-details.component.scss'],
})
export class SkuStockDetailsComponent implements OnInit {
  pageTitle :string;

  @Input() orderStatus :string;

  @Input() rfq :RFQ;

  private readonly _filters = new BehaviorSubject<any>(<any>{});
  public filters$ = this._filters.asObservable();

  constructor(public activeModal :NgbActiveModal) {}

  ngOnInit() :void {
    this.pageTitle = `[${this.rfq.internal_sku}] ${this.rfq.product_name}`;
    this._filters.next({ rfqId: this.rfq.id });
  }
}
